export default {
  title: 'Einloggen',
  emailPH: 'Email',
  pwdPH: 'Passwort',
  submitTxt: 'Einloggen',
  busyTxt: 'Bitte Warten...',
  errMsg: 'Deine Anmeldung war nicht erfolgreich - prüfe Deine Eingaben!',
  registerHint1: 'Noch keinen Account ?',
  registerHint2: 'Hier geht es zur Anmeldung'
}
